import PropTypes from 'prop-types';
// material
import { Typography } from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot
} from '@mui/lab';
// utils

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

OrderItem.propTypes = {
  item: PropTypes.object,
  isLast: PropTypes.bool
};

function OrderItem({ item, isLast }) {
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot />
        {isLast ? null : <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <Typography variant="subtitle1">{item.title}</Typography>
      </TimelineContent>
    </TimelineItem>
  );
}

FlightReviewAeroTimeline.propTypes = {
  analyse: PropTypes.object,
  reportTrip: PropTypes.object
};
export default function FlightReviewAeroTimeline({ analyse, reportTrip }) {
  let currentAero;
  const TIMELINES = analyse.analyseAtterrissageReports
    .map((item) => {
      if (
        item.oaci !== currentAero &&
        item.oaci !== reportTrip.oaciAeroStart &&
        item.oaci !== reportTrip.oaciAeroEnd
      ) {
        currentAero = item.oaci;
        return { title: item.oaci };
      }
      return null;
    })
    .filter((item) => item !== null);

  return (
    <Timeline>
      {TIMELINES.map((item, index) => (
        <OrderItem key={item.title} item={item} isLast={index === TIMELINES.length - 1} />
      ))}
    </Timeline>
  );
}
